// components/Tables/AttendanceTable.js
import React from 'react';

const AttendanceTable = ({ data = [], onViewDetails }) => {
  return (
    <div className="table-responsive">
      <table className="table table-history mb-0">
        <thead>
          <tr>
            <th>Садочок</th>
            <th>Група</th>
            <th>Кількість днів</th>
            <th>Дати</th>
          </tr>
        </thead>
        <tbody>
          {data.map((attend, index) => (
            <tr key={index}>
              <td>{attend.kg.number}</td>
              <td>{attend.gr.number} {attend.gr.name}</td>
              <td>{attend.dates.length}</td>
              <td>{attend.dates.map(d=>`${d.split('-')[2].split('T')[0]}.${d.split('-')[1]}`).join(", ") }</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceTable;